var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 14.5834H10.0084M6.83341 18.3334H13.1667C14.1002 18.3334 14.5669 18.3334 14.9234 18.1518C15.237 17.992 15.492 17.737 15.6518 17.4234C15.8334 17.0669 15.8334 16.6002 15.8334 15.6667V4.33341C15.8334 3.39999 15.8334 2.93328 15.6518 2.57676C15.492 2.26316 15.237 2.00819 14.9234 1.8484C14.5669 1.66675 14.1002 1.66675 13.1667 1.66675H6.83341C5.89999 1.66675 5.43328 1.66675 5.07676 1.8484C4.76316 2.00819 4.50819 2.26316 4.3484 2.57676C4.16675 2.93328 4.16675 3.39999 4.16675 4.33342V15.6667C4.16675 16.6002 4.16675 17.0669 4.3484 17.4234C4.50819 17.737 4.76316 17.992 5.07676 18.1518C5.43328 18.3334 5.89999 18.3334 6.83341 18.3334ZM10.4167 14.5834C10.4167 14.8135 10.2302 15.0001 10.0001 15.0001C9.76996 15.0001 9.58341 14.8135 9.58341 14.5834C9.58341 14.3533 9.76996 14.1667 10.0001 14.1667C10.2302 14.1667 10.4167 14.3533 10.4167 14.5834Z",
    stroke: "#444444",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.0536c615541f36c8a8cace9596cd8744.svg";
export { ForwardRef as ReactComponent };